// The Vue build version to load with the `import` command  版本更新测试20220811_v1.1
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import VueCookie from 'vue-cookie'
import Lodash from 'lodash'
import NProgress from 'nprogress'
import Apis from './store/apis'
import CustomConfig from './store/config'
import VModal from 'vue-js-modal'
import infiniteScroll from 'vue-infinite-scroll'
import nologin from './components/basic/nologin'
import Agile from './components/basic/Agile'
import ResultMsg from './components/basic/result.msg'
import VueClipboard from 'vue-clipboard2'
import Boom from './store/methods'
import 'babel-polyfill'

// Style
import './assets/reset.css'
import './assets/common.css'
import './assets/noprogress.css'
import './assets/toast.css'

// 生产模式需要是阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

// Use
Vue.use(VueCookie)
Vue.use(Apis)
Vue.use(infiniteScroll)
Vue.use(VueClipboard)
Vue.use(VModal, { dialog: true })
Vue.component('nologin', nologin)
Vue.component('agile', Agile)
Vue.component('rmsg', ResultMsg)


// 注册全局lodash
Object.defineProperty(Vue.prototype, '$NProgress', {
  get: function get() {
    return NProgress
  }
})

// 注册全局lodash
Object.defineProperty(Vue.prototype, '$lodash', {
  get: function get() {
    return Lodash
  }
})

// 注册全局lodash
Object.defineProperty(Vue.prototype, '$boom', {
  get: function get() {
    return Boom
  }
})

// 自定义全局配置
Vue.customConfig = CustomConfig
Vue.customConfig.is_weixin = isWeixn() // 判断是否为微信浏览器
Object.defineProperty(Vue.prototype, '$APP_CONFIG', {
  get: function get() {
    return CustomConfig
  }
})

// 设置全局字体大小
setFrame()
window.onresize = function(){
  setFrame()
}

// 屏幕旋转
window.addEventListener('orientationchange', function(event){
  if ( window.orientation == 180 || window.orientation== 0 || window.orientation == 90 || window.orientation == -90) {
    setFrame()
  }
})


// 登录排除
const excludeLoginRoute = ['login', 'set.psswd', 'reset.psswd', 'pay.success', 'pay.error', 'bee.intro']
window.$url_from = {} // 记录当前路由

// 路由Start
router.beforeEach((to, from, next) => {

  // 设置title
  document.title = to.meta.title
  document.body.scrollTop = document.documentElement.scrollTop = 0
  NProgress.start()

  // 排除相关路由不记录来源路由
  const inExcludeLoginRoute = Lodash.findIndex(excludeLoginRoute, name => name == to.name) != -1
  if(!inExcludeLoginRoute){
    window.$url_from = {
      name: to.name,
      params: to.params,
      query: to.query
    } // 全局来源
  }
  next()
})

// 登录排除
const excludeShare = ['course.detail', 'profession.detail', 'pay.info']

// 路由End
router.afterEach((to) => {
  
  // 排除相关路由不设置分享
  const inExcludeShareRoute = Lodash.findIndex(excludeShare, name => name == to.name) != -1
  if(!inExcludeShareRoute){
    store.commit('shareWeixin', {
      title: `[优课在线]-${to.meta.title}`,
      desc: '专注在线教育, 专注高等教育',
      imgUrl: CustomConfig.UOOC_LOGO
    })
  }

  NProgress.done()
})

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// 适配全局字体大小
function setFrame(){
  const screenWidth = window.screen.width
  const APP = document.getElementById('app')
  let fisze = screenWidth > 1080 ? 144 : screenWidth / 7.5
  fisze = fisze > 32 ? fisze : 32
  document.getElementsByTagName('html')[0].style.fontSize = fisze + 'px'
  APP.style.width = Math.floor(6.9 * parseInt(fisze))
}

// 是否为微信浏览器
function isWeixn(){ 
  const ua = navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}



// WEBPACK FOOTER //
// ./src/main.js